var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPortHole = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 704 320"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 448.438,
  cy: 90.5,
  rx: 292.479,
  ry: 292.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M1340-210H-421v603h1761zM448.437 383c161.532 0 292.479-130.957 292.479-292.5S609.969-202 448.437-202 155.958-71.043 155.958 90.5 286.906 383 448.437 383",
  clipRule: "evenodd"
})));
export default SvgPortHole;